import {ArrowUpIcon} from '@primer/octicons-react'
import {useEffect, useMemo, useRef, useState} from 'react'

import useIntersectionObserver from '../../../../lib/hooks/useIntersectionObserver'

export interface BackToTopProps {}

const COPY = {
  aria: 'Back to top',
}

const defaultProps: Partial<BackToTopProps> = {}

const BackToTop: React.FC<BackToTopProps> = props => {
  // eslint-disable-next-line unused-imports/no-unused-vars
  const initializedProps = {...defaultProps, ...props}

  const [isMounted, setMounted] = useState<boolean>(false)
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const heroRef = useRef<HTMLDivElement | null>(null)

  const {isIntersecting: isHeroActive} = useIntersectionObserver(heroRef, {threshold: 0.4})

  const url = useMemo(() => (isMounted ? `${location.pathname}${location.search}#hero` : ''), [isMounted])

  useEffect(() => {
    setMounted(true)
    heroRef.current = document.querySelector('#hero')
  }, [])

  useEffect(() => {
    setIsVisible(!isHeroActive)
  }, [isHeroActive])

  // TODO: Review accessibility
  return (
    <div className={`BackToTop ${isVisible ? 'BackToTop--visible' : ''}`}>
      <a href={url} aria-label={COPY.aria}>
        <ArrowUpIcon />
      </a>
    </div>
  )
}

export default BackToTop
